import React from 'react';
import { PropTypes } from 'prop-types';
import Button from '../../../componentsV2/Button/Button';
import Breadcrumbs from '../../../componentsV2/Breadcrumbs/Breadcrumbs';
import PagesHeader from '../../../componentsV2/Headers/PagesHeader';

const AccountPage = ({
  initialData = {
    firstName: '',
    lastName: '',
    email: '',
  },
}) => {
  const breadcrumbLinks = [
    { href: '/admin', name: 'Admin' },
    { href: '/account', name: 'Account' },
  ];

  const fields = [
    { label: 'First name', value: initialData.firstName },
    { label: 'Last name', value: initialData.lastName },
    { label: 'Email', value: initialData.email },
    { label: 'Current password', value: '\u2022'.repeat(18) },
  ];

  return (
    <div className="w-[80%]">
      <div className="mx-2.75">
        <header>
          <Breadcrumbs links={breadcrumbLinks} />
        </header>
        <div className="flex flex-col mt-2">
          <div className="w-full">
            <div className="flex justify-between border-b border-vamos-blue-gray pb-2">
              <PagesHeader name="account_green" label="Account" size="h-9" wrapDivClass="py-0" />
              <Button
                label="Edit"
                size="md"
                className="px-6"
                onClick={() => {
                  window.location.href = '/users/edit';
                }}
              />
            </div>

            <div className="w-full justify-start mt-5">
              {fields.map(({ label, value }) => (
                <div key={label} className="flex flex-row gap-x-8 mb-5">
                  <h3 className="font-medium text-lg w-40">{label}</h3>
                  <p className={`col-span-2 ${label === 'Current password' ? 'text-2xl' : ''}`}>{value}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AccountPage.propTypes = {
  initialData: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
  }),
};

export default AccountPage;
